import React from 'react'
import Header from '../../Component/Header'
import Footer from '../../Component/Footer'
import Gallery from '../Gallery'

export default function LayoutGallery() {
    return (
        <>
            <Header />
            <Gallery />
            <Footer />
        </>
    )
}
